const defaultSEO = {
  title: "Would You Rather Questions | Would U",
  description:
    "Play endless Would You Rather questions online with Would U - the ultimate platform for fun, creative, and challenging dilemmas. Start playing now!",
  keywords:
    "would you rather questions, would you rather game, online would you rather, fun questions, party game",
  image: "/default-og-image.png",
  siteUrl: "https://would-u.com",
};

export const seo = ({
  title = defaultSEO.title,
  description = defaultSEO.description,
  keywords = defaultSEO.keywords,
  image = defaultSEO.image,
}: {
  title?: string;
  description?: string;
  image?: string;
  keywords?: string;
}) => {
  const formattedTitle = title.includes("Would U")
    ? title
    : `${title} | Would U`;

  const tags = [
    { title: formattedTitle },
    { name: "description", content: description },
    { name: "keywords", content: keywords },
    { property: "og:type", content: "website" },
    { property: "og:title", content: formattedTitle },
    { property: "og:description", content: description },
    { property: "og:image", content: image },
    { property: "og:url", content: defaultSEO.siteUrl },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: formattedTitle },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: image },
    { name: "robots", content: "index, follow" },
  ];

  return tags;
};
